import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment-timezone';

@Pipe({
    name: 'momentFormat',
    standalone: true
})
export class MomentFormatPipe implements PipeTransform {
    transform(value: Date | moment.Moment | string | null | undefined, format: string = 'DD-MMM-YYYY'): string {
        if (!value) return '';
        return moment(value).format(format);
    }
}

@Pipe({
    name: 'pstToLocal',
    standalone: true
})
export class PstToLocalPipe implements PipeTransform {
    transform(value: Date | moment.Moment | string, ...args: any[]): any {
        if (!value) return '';
        
        let [format, showTimezone = true] = args;
        if (!format) format = 'DD MMM YYYY : HH:mm A';
        
        // Convert PST date to local timezone
        const localDate = (moment as any).tz(value, 'America/Los_Angeles').local();
        
        if (showTimezone) {
            const timezoneAbbr = (moment as any).tz.guess() ? (moment as any).tz((moment as any).tz.guess()).format('z') : 'Local';
            return localDate.format(format) + ` (${timezoneAbbr})`;
        }
        
        return localDate.format(format);
    }
}

@Pipe({
    name: 'momentFormatTimezone',
    standalone: true
})
export class MomentFormatTimezonePipe implements PipeTransform {
    transform(value: Date | moment.Moment | string | null | undefined, timezone: string, ...args: any[]): string {
        if (!value || !timezone) return '';
        const [format = 'DD-MMM-YYYY HH:mm'] = args;
        return (moment as any).utc(value).tz(timezone).format(format);
    }
}
